// store.js
import settingsReducer from "./slices/settingsSlice";
import authReducer from "./slices/authSlice";
import onboardingReducer from "./slices/onboardingSlice";
import notificationsReducer from "./slices/notificationsSlice";
import layoutReducer from "./layout/reducer";
import profileReducer from "./auth/profile/reducer";
import accountReducer from "./auth/register/reducer";
import forgetPasswordReducer from "./auth/forgetpwd/reducer";
// import redux and persist plugins
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import storage from "redux-persist/lib/storage";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth", "onboarding"],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    settings: settingsReducer,
    auth: authReducer,
    onboarding: onboardingReducer,
    notifications: notificationsReducer,
    Layout: layoutReducer,
    Profile: profileReducer,
    Account: accountReducer,
    ForgetPassword: forgetPasswordReducer,
  })
);
const store = configureStore({
  reducer: persistedReducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
const persistedStore = persistStore(store);
export { store, persistedStore };